<head>
    <meta
      name="description"
      content="Lilly ist die Katze von Leon, die er damals aus einem Kroatien Urlaub nach Deutschland gebracht hat. Als Frontyard Predator und Hundesitter hat sie recht viel um die Ohren 
      aber für Thunfisch lässt sie alles liegen und stehen."
    />
</head>
<div class="bg" animate.enter="entering">
    <div class="home-container">
        <div class="headline">
            <div class="text_container"><h1 class="header">All eyes on tuna and sleeping</h1>
        </div>
        </div>
        <div class="content">
            <app-content-card>
                <app-data-card-lilly></app-data-card-lilly>
                <app-about-lilly class="accent"></app-about-lilly>
                <h2 class="accent">skills.</h2>
                <app-chip [chips]="chips" class="accent"></app-chip>
                <app-links class="accent" Instagram="{{Instagram}}"></app-links>
                <app-footer class="accent"></app-footer>
            </app-content-card>
        </div>
    </div>
</div>
